<template>
  <div></div>
</template>

<script>
import pdfMake from "pdfmake";
import htmlToPdfmake from "html-to-pdfmake";
import pdfFonts from "../../../assets/build/vfs_fonts";
import apiConfig from "../../../config/api";

import moment from "moment";

import { Decode, Encode } from "@/services";
import userApi from "@/api/user/";
import { toFixed } from "ant-design-vue/lib/input-number/src/utils/MiniDecimal";

import { ArabicNumberToText } from "../../../utils/numberToText";

import JsBarcode from "jsbarcode/bin/JsBarcode";
import { right } from "@popperjs/core";
import dayjs, { Dayjs } from "dayjs";

export default {
  props: {
    dataExport: Object,
  },
  data: () => ({
    companyData: [],
    newProduct: [],
    headerTable: [],
    user: "",
    numberToTh: "",
    sumRequestStockAmt: null,
    sumAmount: 0,
    // logoimage: require("@/images/yili_cremo_logo.png"),
    logoimage:
      "data:image/png;base64,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",
  }),
  async created() {
    // await this.getUser();
    console.log("dataExprt", this.dataExport);
    await this.getOneCompany();
    await this.exports();
  },

  methods: {
    async getOneCompany() {
      let responseData = [];
      try {
        responseData = await userApi.company.getOne(
          this.dataExport.companyId
            ? this.dataExport.companyId
            : localStorage.getItem("companyId")
        );
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        this.companyData = responseData.data;
      }
    },
    setCustomer() {
      this.headerTable.push([
        {
          rowSpan: 2,
          fontSize: 8.0,
          bold: true,
          border: [true, true, true, true],
          text: "Invoice Number",
        },
        {
          rowSpan: 2,
          fontSize: 8.0,
          bold: true,
          border: [true, true, true, true],
          text: "Invoice Date",
        },
        {
          rowSpan: 2,
          fontSize: 8.0,
          bold: true,
          border: [true, true, true, true],
          text: "Customer No.",
        },
        {
          rowSpan: 2,
          fontSize: 8.0,
          bold: true,
          border: [true, true, true, true],
          text: "CO. no.",
        },
        {
          rowSpan: 2,
          fontSize: 8.0,
          bold: true,
          border: [true, true, true, true],
          text: "",
        },
      ]);
      this.headerTable.push(["rowspan"]);
      this.headerTable.push([
        {
          text: `${
            this.dataExport.transaction_number
              ? this.dataExport.transaction_number
              : "-"
          } `,
          fontSize: 8.0,
          border: [true, true, true, true],
        },
        {
          text: `${
            this.dataExport.invoice_date
              ? dayjs(this.dataExport.invoice_date).format("DD/MM/YYYY")
              : this.convertDate(this.dataExport.date)
          }`,
          fontSize: 8.0,
          border: [true, true, true, true],
        },
        {
          text: `${
            this.dataExport.customer
              ? this.dataExport.customer.code
              :' this.dataExport.customer.code'
          }`,
          fontSize: 8.0,
          border: [true, true, true, true],
        },
        {
          text: `CO. No.`,
          fontSize: 8.0,
          border: [true, true, true, true],
        },
        {
          text: `กรุงสยาม`,
          fontSize: 8.0,
          border: [true, true, true, true],
        },
      ]);
    },
    setProduct() {
      this.dataExport.products.forEach((product, index) => {
        // this.sumAmount += product.item_amt;
        let displayDiscount = [];

        if (index === 0) {
          // "รหัสสินค้า",
          // "รายการสินค้า",
          // "หน่วย",
          // "จำนวน",
          // "ราคา/หน่วย",
          // "ราคาเต็ม",
          // "ส่วนลด%",
          // "จำนวนเงิน",
          this.newProduct.push([
            {
              rowSpan: 2,
              fontSize: 8.0,
              bold: true,
              border: [true, true, true, true],
              text: "No.",
            },

            {
              rowSpan: 2,
              fontSize: 8.0,
              bold: true,
              border: [true, true, true, true],
              text: "Qty. Ret.",
            },
            {
              rowSpan: 2,
              fontSize: 8.0,
              bold: true,
              border: [true, true, true, true],
              text: "Item Number",
              alignment: "right",
            },
            {
              rowSpan: 2,
              fontSize: 8.0,
              bold: true,
              border: [true, true, true, true],
              text: "Description",
              alignment: "right",
            },
            {
              rowSpan: 2,
              fontSize: 8.0,
              bold: true,
              border: [true, true, true, true],
              text: "Unit price",
              alignment: "right",
            },
            {
              rowSpan: 2,
              fontSize: 8.0,
              bold: true,
              border: [true, true, true, true],
              text: "UOM",
              alignment: "right",
            },

            {
              rowSpan: 2,
              fontSize: 8.0,
              bold: true,
              border: [true, true, true, true],
              text: "Extended",
              alignment: "right",
            },
          ]);
          this.newProduct.push(["rowspan"]);
        }
        this.newProduct.push([
          {
            // text: product.item_code ? product.item_code : product.product.code,
            text: index + 1,
            border: [true, false, true, false],
            fontSize: 8.0,
            // alignment: "right",
          },
          {
            text: product.item_amt,
            border: [true, false, true, false],
            fontSize: 8.0,
          },
          {
            text: product.item_code ? product.item_code : product.product.code,
            border: [true, false, true, false],
            fontSize: 8.0,
            alignment: "right",
          },
          {
            // text: product.item_amt,
            text: product.item_name ? product.item_name : product.product.name,
            border: [true, false, true, false],
            fontSize: 8.0,
            alignment: "right",
          },
          {
            text:
              product.item_unit == "Pieces"
                ? "PCS."
                : product.item_unit == "Carton"
                ? "CTN."
                : "SET",

            // text: product.item_price, //ราคา
            border: [true, false, true, false],
            fontSize: 8.0,
            alignment: "right",
          },
          {
            text: product.item_price, //ราคา
            // text: (product.item_price * product.item_amt * 1).toFixed(2),
            border: [true, false, true, false],
            fontSize: 8.0,
            alignment: "right",
          },
          {
            // text: (
            //   product.item_price * product.item_amt -
            //   displayDiscount
            // ).toFixed(2),
            text: (product.item_price * product.item_amt).toFixed(2),
            border: [true, false, true, false],
            fontSize: 8.0,
            alignment: "right",
          },
        ]);
      });
    },
    // checkDiscount(item) {
    //   this.dataExport.discounts.filter((element) => {
    //     if (element.productDiscount.id == item.id) {
    //       console.log("pair");
    //       return "มีส่วนลด";
    //     } else {
    //       return "-";
    //     }
    //   });
    // },
    async getUser() {
      const userId = Decode.decode(localStorage.getItem("boss"));

      let responseData = [];

      try {
        responseData = await userApi.user.getAll();
      } catch (error) {
        console.log(error);
      }
      if (responseData.response_status === "SUCCESS") {
        const users = responseData.data;
        const findUser = users.find((data) => data.id === parseInt(userId));
        if (findUser) {
          this.user = findUser;
        }
      }
    },

    exports() {
      const newWindow = window.open("", "_blank");

      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        Roboto: {
          normal: "Kanit-Regular.ttf",
          bold: "Kanit-Bold.ttf",
          italics: "Kanit-Medium.ttf",
          bolditalics: "Kanit-Medium.ttf",
          // Pridi-Medium.ttf
        },
      };

      //setProduct Arr
      this.setProduct();
      this.setCustomer();

      // convert num to text TH
      this.convertNumberToTh();

      const html = [
        {
          table: {
            columnGap: 10,
            widths: ["25%", "*", "20%"],
            body: [
              [
                {
                  rowSpan: 2,
                  image: `${this.logoimage}`,
                  width: 117,
                  height: 52,
                  border: [false, false, false, false],
                  margin: [-10, 0, 0, 0],
                },
                {
                  text: this.companyData.full_name,
                  fontSize: 8.0,
                  // alignment: "center",
                  bold: true,
                  border: [false, false, false, false],
                  margin: [-5, 0, 0, 0],
                },
                {
                  text: `${this.dataExport.isCopy ? "สำเนา" : ""}`,
                  margin: [0, 0, 0, 0],
                  fontSize: 14.5,
                  bold: true,
                  border: [false, false, false, false],
                  margin: [-5, -15, 0, 0],
                },
              ],
              [
                {
                  text: ``,
                  border: [false, false, false, false],
                },
                {
                  text: `เลขที่ ${
                    this.companyData.address ? this.companyData.address : ""
                  } หมู่ที่ ${
                    this.companyData.moo ? this.companyData.moo : ""
                  } \nตำบล ${
                    this.companyData.sub_district
                      ? this.companyData.sub_district
                      : ""
                  } อำเภอ ${
                    this.companyData.district ? this.companyData.district : ""
                  } \nจังหวัด ${
                    this.companyData.provice ? this.companyData.provice : ""
                  } ${this.companyData.postcode} \nทะเบียนการค้าเลขที่ ${
                    this.companyData.tax_id ? this.companyData.tax_id : ""
                  } `,
                  fontSize: 8.0,
                  border: [false, false, false, false],
                  margin: [-5, 0, 0, 0],
                },
                {
                  text: `${
                    this.dataExport.invoice_date
                      ? dayjs(this.dataExport.invoice_date).format("DD/MM/YYYY")
                      : this.convertDate(this.dataExport.date)
                  }`,
                  fontSize: 8.0,
                  border: [false, false, false, false],
                  margin: [-5, -15, 0, 0],
                },
              ],
              [
                {
                  text: ``,
                  fontSize: 8.0,
                  border: [false, false, false, false],
                  margin: [-5, -5, 0, 4],
                },
                {
                  text: `เลขประจำตัวผู้เสียภาษีอากร	0125521000029`,
                  fontSize: 8.0,
                  border: [false, false, false, false],
                  margin: [-5, -5, 0, 4],
                },
                {
                  text: "",
                  fontSize: 8.0,
                  border: [false, false, false, false],
                  margin: [-5, -5, 0, 4],
                  bold: true,
                },
              ],
            ],
          },
        },
        {
          text: `ใบลดหนี้`,
          fontSize: 14.5,
          alignment: "center",
          bold: true,
        },
        {
          text: "CREDIT NOTE",
          margin: [0, 0, 0, 4],
          fontSize: 14.5,
          alignment: "center",
          bold: true,
        },
        // LINE SOLID
        // {
        //   canvas: [
        //     {
        //       type: "line",
        //       x1: 0,
        //       y1: 5,
        //       x2: 595 - 2 * 81,
        //       y2: 5,
        //       lineWidth: 1,
        //     },
        //   ],
        //   margin: [0, -5, 0, 5],
        // },

        {
          table: {
            widths: ["50%", "50%"],
            body: [
              [
                {
                  text: `Sold To :  `,

                  fontSize: 8,
                  border: [true, true, true, false],
                  margin: [0, 0, 0, 0],
                  bold: true,
                },
                {
                  text: `Ship To :`,

                  fontSize: 8,
                  border: [true, true, true, false],
                  bold: true,
                  margin: [0, 0, 0, 0],
                },
              ],
              [
                {
                 text: `${
                    this.dataExport.customer.name
                      ? this.dataExport.customer.name
                      : ""
                  } ${
                    this.dataExport.customer
                      ? this.dataExport.customer.branch.invoice_name
                      : ""
                  } \n ${
                    this.dataExport.customer.address
                      ? this.dataExport.customer.address
                      : ""
                  } \nเลขประจำตัวผู้เสียภาษีอากร ${
                    this.dataExport.customer.tax_id
                      ? this.dataExport.customer.tax_id
                      : "-"
                  } \n ${
                    this.dataExport.customer.tel
                      ? this.dataExport.customer.tel
                      : // ? this.dataExport.customer
                        // : this.dataExport.customer.tax_id
                        ""
                  }`,
                  fontSize: 8,
                  border: [true, false, true, true],
                },

                {
                 text: `${
                    this.dataExport.customer.name
                      ? this.dataExport.customer.name
                      : ""
                  } ${
                    this.dataExport.customer
                      ? this.dataExport.customer.branch.invoice_name
                      : ""
                  } \n ${
                    this.dataExport.customer.address
                      ? this.dataExport.customer.address
                      : ""
                  } \nเลขประจำตัวผู้เสียภาษีอากร ${
                    this.dataExport.customer.tax_id
                      ? this.dataExport.customer.tax_id
                      : "-"
                  } \n ${
                    this.dataExport.customer.tel
                      ? this.dataExport.customer.tel
                      : // ? this.dataExport.customer
                        // : this.dataExport.customer.tax_id
                        ""
                  }`,
                  fontSize: 8,
                  border: [true, false, true, true],
                },
              ],
            ],
          },
        },

        // TABLE

        {
          bold: false,
          fontSize: 10,
          color: "black",

          table: {
            widths: ["*", "*", "*", "*", "*"],
            body: this.headerTable,
          },
          margin: [0, 5, 0, 0],
        },
        // TABLE
        {
          bold: false,
          fontSize: 10,
          color: "black",
          table: {
            // heights: function (row) {
            //   let last = row[row.length - 1];
            //   console.log('last',last);
            //   return last * 250;
            // },
            // heights:[0,0,0,0,0,0,254],
            // heights: auto,
            widths: [30, 50, 80, "*", 50, 50, 50],
            body: this.newProduct,
          },
          style:'tableProduct',
          margin: [0, 10, 0, 0],
        },
        // LINE SOLID
        // {
        //   canvas: [
        //     {
        //       type: "line",
        //       x1: 0,
        //       y1: 5,
        //       x2: 595 - 2 * 40,
        //       y2: 5,
        //       lineWidth: 1,
        //     },
        //   ],
        //   margin: [0, 0, 0, 0],
        // },

        // {
        //   canvas: [
        //     {
        //       type: "line",
        //       x1: 0,
        //       y1: 5,
        //       x2: 595 - 2 * 40,
        //       y2: 5,
        //       lineWidth: 1,
        //     },
        //   ],
        //   margin: [0, 0, 0, 0],
        // },

        {
          // fontSize: 10,
          // color: "black",
          table: {
            fontSize: 8,
            widths: ["*", 79.5, 79.5],
            columnGap: 2,
            body: [
              [
                {
                  text: `มูลค่าตามใบกำกับภาษีเดิม`,
                  border: [true, true, true, false],
                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,
                },
                {
                  text: `รวม`,
                  border: [true, true, true, false],
                  alignment: right,

                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,
                },
                {
                  text: (this.dataExport.total_price_summary).toFixed(2),
                  border: [true, true, true, false],

                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,
                  alignment: right,
                },
              ],
              [
                {
                  text: `มูลค่าใบกำกับภาษีที่ถูกต้อง`,
                  border: [true, false, true, false],
                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,
                },
                {
                  text: `ส่วนลด`,
                  border: [true, false, true, false],
                  alignment: right,

                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,
                },
                {
                  text: `0.00`,
                  border: [true, false, true, false],

                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,

                  alignment: right,
                },
              ],
              [
                {
                  text: `ผลต่างราคา`,
                  border: [true, false, true, false],
                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,
                },
                {
                  text: `คงเหลือ`,
                  border: [true, false, true, false],
                  alignment: right,

                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,
                },
                {
                  text: (this.dataExport.total_price_summary).toFixed(2),
                  border: [true, false, true, false],

                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,

                  alignment: right,
                },
              ],
              [
                {
                  text: ``,
                  border: [true, false, true, false],
                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,
                },
                {
                  text: `VAT. 7%`,
                  border: [true, false, true, false],
                  alignment: right,

                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,
                },
                {
                  text: (this.dataExport.vat).toFixed(2),
                  border: [true, false, true, false],

                  color: "black",
                  style: "tableBody",
                  lineHeight: 1,

                  alignment: right,
                },
              ],
            ],
          },
        },
        {
          // fontSize: 10,
          // color: "black",
          table: {
            fontSize: 8,
            widths: ["*", 79.5, 79.5],
            body: [
              [
                {
                  text: `หมายเหตุ: ยกเลิกบิลขาย`,
                  border: [true, true, true, false],
                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,
                },
                {
                  text: ``,
                  border: [true, true, true, false],
                  alignment: right,

                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,
                },
                {
                  text: ``,
                  border: [true, true, true, false],

                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,

                  alignment: right,
                },
              ],
              [
                {
                  text: `ใบกำกับภาษีเดิม ${this.dataExport.invoice_number}`,
                  border: [true, false, true, false],
                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,
                },
                {
                  text: `ยอดรวมทั้งสิ้น`,
                  border: [true, false, true, false],
                  alignment: right,

                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,
                },
                {
                  text: (this.dataExport.final_price).toFixed(2),
                  border: [true, false, true, false],

                  color: "black",
                  style: "tableBody",
                  lineHeight: 0.5,

                  alignment: right,
                },
              ],
              [
                {
                  // text: `Ref: 0368820021`,
                  text: ``,
                  border: [true, false, true, true],
                  color: "black",
                  style: "tableBody",
                  lineHeight: 2,
                },
                {
                  text: ``,
                  border: [true, false, true, true],
                  alignment: right,

                  color: "black",
                  style: "tableBody",
                  lineHeight: 2,
                },
                {
                  text: ``,
                  border: [true, false, true, true],

                  color: "black",
                  style: "tableBody",
                  lineHeight: 2,

                  alignment: right,
                },
              ],
            ],
          },
        },

        // SIGNATURE
        {
          columns: [
            {
              width: "25%",
              text: "..................................................................",
              fontSize: 10,
              margin: [0, 30, 0, 0],
              alignment: "center",
            },
            {
              width: "25%",
              text: "..................................................................",
              fontSize: 10,
              margin: [0, 30, 0, 0],
              alignment: "center",
            },
            {
              width: "25%",
              text: "..................................................................",
              fontSize: 10,
              margin: [0, 30, 0, 0],
              alignment: "center",
            },
            {
              width: "25%",
              text: "..................................................................",
              fontSize: 10,
              margin: [0, 30, 0, 0],
              alignment: "center",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
        },
        // APPROVE
        {
          columns: [
            {
              width: "25%",
              text: "ผู้จัดทำ",
              fontSize: 10,
              margin: [0, -5, 0, 0],
              alignment: "center",
            },
            {
              width: "25%",
              text: "ผู้ตรวจสอบ",
              fontSize: 10,
              margin: [0, -5, 0, 0],
              alignment: "center",
            },
            {
              width: "25%",
              text: "ผู้ลงบัญชี",
              fontSize: 10,
              margin: [0, -5, 0, 0],
              alignment: "center",
            },
            {
              width: "25%",
              text: "ผู้มีอำนาจลงนาม",
              fontSize: 10,
              margin: [0, -5, 0, 0],
              alignment: "center",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 0],
        },

        // จบแถวแรก

        // {
        //   canvas: [
        //     {
        //       type: "line",
        //       x1: 0,
        //       y1: 5,
        //       x2: 595 - 2 * 40,
        //       y2: 5,
        //       lineWidth: 1,
        //     },
        //   ],
        //   margin: [0, 0, 0, 0],
        // },
      ];

      const pdfData = {
        pageSize: "A4",
        content: html,
        styles: {
          tableHeader: {
            fontSize: 8.0,
            color: "black",
            bold: true,
          },
          tableBody: {
            fontSize: 8.0,
            color: "black",
          },
          tableProduct: {
            height: "auto",
          },
        },
      };
      pdfMake.createPdf(pdfData).open({}, newWindow);
      this.$emit("generatedFile");
    },
    textToBase64Barcode(text) {
      let canvas = document.createElement("canvas");
      JsBarcode(canvas, text, { format: "CODE128", displayValue: false });

      return canvas.toDataURL("image/png");
    },
    // textToBase64Barcode(text) {
    //   let canvas = document.createElement("canvas");
    //   JsBarcode(canvas, text, { format: "CODE39", displayValue: false });

    //   return canvas.toDataURL("image/png");
    // },
    setTotal() {
      // sumRequestStockAmt;
      this.dataExport.productTransfers.forEach((element) => {
        this.sumRequestStockAmt += element.requestStockAmt;
      });
    },

    convertNumberToTh() {
      this.numberToTh = ArabicNumberToText(this.dataExport.final_price);
    },
    convertDate(val) {
      return moment(val).format("DD/MM/YYYY");
      // return moment(val).format("DD/MM/YYYY - HH:mm:ss น.");
    },
  },
};
</script>
